<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1474lDf/tc-custom/9780547526959.jpg?1726574179252" alt="This image is the cover for the book Bury the Chains"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bury the Chains
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From the author of <i>King Leopold’s Ghost</i>, a narrative history of the social justice campaign formed in the fight to free the slaves of the British Empire.</b></p><p>In early 1787, twelve men—a printer, a lawyer, a clergyman, and others united by their hatred of slavery—came together in a London printing shop and began the world's first grass-roots movement, battling for the rights of people on another continent. Masterfully stoking public opinion, the movement's leaders pioneered a variety of techniques that have been adopted by citizens' movements ever since, from consumer boycotts to wall posters and lapel buttons to celebrity endorsements. A deft chronicle of this groundbreaking antislavery crusade and its powerful enemies, <i>Bury the Chains</i> gives a little-celebrated human rights watershed its due.</p><p><b>A <i>San Francisco Chronicle</i> Bestseller</b></p><p><b>A Book Sense Selection</b></p><p><b>“By far the most readable and rounded account we have of British antislavery, a campaign that, as the author rightly claims, helped to change the world and can be seen as a prototype of the modern social justice movement.” —Robin Blackburn, <i>Los Angeles Times Book Review</i></b><b><i> </i></b></p><b>“A thrilling, substantive, and oftentimes raw work of narrative history. In its own fashion, it furthers the abolitionists’ crucial work of lifting our moral blindness.” —Maureen Corrigan, National Public Radio’s <i>Fresh Air</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adam Hochschild
      </h2>
      
      <p class="authorDescription body article">Adam Hochschild is the author of seven books.&#160;<I>King Leopold&#39;s Ghost</I>&#160;was a finalist for the National Book Critics Circle Award, as was his recent&#160;To End All Wars. His&#160;<I>Bury the Chains</I>&#160;was a finalist for the National Book Award and won the Los Angeles Times Book Prize and PEN USA Literary Award. He lives in Berkeley, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cab74b62